export { default } from './BotonsPrevisio';
